<mat-expansion-panel class="pulse-adv-panel" (opened)="onOpened()">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Opciones avanzadas
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="adv-wrapper" [formGroup]="form">

    <div class="loading" *ngIf="loading">
      Cargando...
    </div>

    <!-- 1) Lectura actual -->
    <div class="section">
      <div class="current-row">
        <div class="section-title">Lectura actual:</div>

        <div class="current-counter" aria-label="Lectura actual del contador">
          <span class="counter-digit" *ngFor="let digit of currentIntegerDigits">{{ digit }}</span>
          <span class="counter-separator" *ngIf="currentDecimalDigits.length">.</span>
          <span class="counter-digit decimal" *ngFor="let digit of currentDecimalDigits">{{ digit }}</span>
          <span class="unit">m³</span>
        </div>
      </div>
    </div>

    <!-- 2) Nuevo formato (editable) -->
    <div class="section">
      <div class="section-title">Formato del Contador</div>

      <div class="format-row">
        <mat-form-field appearance="fill" class="small">
          <mat-label>Dígitos</mat-label>
          <input matInput type="number" formControlName="digits" min="1" max="8" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="small">
          <mat-label>Decimales</mat-label>
          <input matInput type="number" formControlName="decimals" min="0" max="3" />
        </mat-form-field>

        <div class="inline-preview">
          <span class="arrow">→</span>
          <span class="preview-value mono">{{ newPreview }} <span class="unit">m³</span></span>
        </div>
      </div>
    </div>

    <!-- 3) Sincronizar contador -->
    <div class="section">
      <div class="section-title">Nuevo valor del Contador</div>

      <div class="sync-row">
        <mat-form-field appearance="fill" class="medium">
          <mat-label>Valor del contador</mat-label>
          <input matInput type="text" formControlName="syncValueHuman" placeholder="Ej: 56600.220"
            (input)="onSyncInput($event)" />
        </mat-form-field>

        <div class="inline-preview" *ngIf="syncPreview">
          <span class="arrow">→</span>
          <span class="preview-value mono">{{ syncPreview }} <span class="unit">m³</span></span>
        </div>
      </div>
    </div>

  </div>
</mat-expansion-panel>
